import React from 'react';
import PropTypes from 'prop-types';
import {
  MultiSelectorContextProvider,
} from '@bingads-webui-campaign-react/multi-selector';

export const BrandListsContextProvider = ({
  children, selectedOptionsLimit, optionsDisplayLimit, useOptions, useSelectedOptions, onChange, onSelectedOptionsUpdate, savedAddedSelectedOptionsKeys, savedDeletedSelectedOptionsKeys,
}) => (
  <MultiSelectorContextProvider
    useOptions={useOptions}
    useSelectedOptions={useSelectedOptions}
    selectedOptionsLimit={selectedOptionsLimit}
    optionsDisplayLimit={optionsDisplayLimit}
    onChange={onChange}
    onSelectedOptionsUpdate={onSelectedOptionsUpdate}
    savedAddedSelectedOptionsKeys={savedAddedSelectedOptionsKeys}
    savedDeletedSelectedOptionsKeys={savedDeletedSelectedOptionsKeys}
  >
    {children}
  </MultiSelectorContextProvider>
);

BrandListsContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  selectedOptionsLimit: PropTypes.number.isRequired,
  optionsDisplayLimit: PropTypes.number.isRequired,
  useOptions: PropTypes.func.isRequired,
  useSelectedOptions: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  onSelectedOptionsUpdate: PropTypes.func,
  savedAddedSelectedOptionsKeys: PropTypes.arrayOf(PropTypes.number),
  savedDeletedSelectedOptionsKeys: PropTypes.arrayOf(PropTypes.number),
};

BrandListsContextProvider.defaultProps = {
  onChange: undefined,
  onSelectedOptionsUpdate: undefined,
  savedAddedSelectedOptionsKeys: [],
  savedDeletedSelectedOptionsKeys: [],
};
